import type { SkuPrices } from "./types";

// What the Products screen works out: what a search box means (a Tare SKU or a customer's part number), sizes in
// inches, and when a price applies. Pure, so it is tested without a browser.

/** A search: TG-… is a Tare SKU (or part of one); anything else, the customer's part number (or part of it). */
export function searchArgs(q: string): Record<string, string> {
  const t = q.trim();
  if (!t) return {};
  return /^TG-/i.test(t) ? { sku: t.toUpperCase() } : { part_number: t };
}

/** Inside or blank dimensions in inches: "15 × 11.5 × 8 in". */
export function dims(d: number[] | null | undefined): string {
  return d && d.length ? `${d.join(" × ")} in` : "";
}

/** A pricing period "[2026-09-28,)" in words: "from 2026-09-28", "2026-09-28 to 2026-12-31". */
export function effective(range: string | null | undefined): string {
  const m = /^[[(]([0-9-]*),([0-9-]*)[\])]$/.exec(range ?? "");
  if (!m) return range ?? "";
  if (m[1] && m[2]) return `${m[1]} to ${m[2]}`;
  if (m[1]) return `from ${m[1]}`;
  return m[2] ? `until ${m[2]}` : "";
}

/** Prices by SKU, for the products on the page. */
export function pricesBySku(rows: SkuPrices[]): Map<string, SkuPrices> {
  return new Map(rows.map((r) => [r.sku, r]));
}
